import { Settings2 } from "lucide-react";
import type { CSSProperties } from "react";

export type TaskDetailsHeaderProps = {
  listName: string;
  colors: {
    bar: string;
    soft: string;
    ink: string;
  };
  onAreaClick?: () => void;
  onOptionsClick?: () => void;
};

export default function TaskDetailsHeader({
  listName,
  colors,
  onAreaClick,
  onOptionsClick,
}: TaskDetailsHeaderProps) {
  const style = {
    "--task-details-bar": colors.bar,
    "--task-details-soft": colors.soft,
    "--task-details-ink": colors.ink,
  } as CSSProperties;

  return (
    <header className="task-details-header" style={style}>
      <button type="button" className="list-button" onClick={onAreaClick}>
        <span className="list-dot" aria-hidden />
        <span className="list-name">{listName}</span>
      </button>
      <button
        type="button"
        className="options-button"
        onClick={onOptionsClick}
        aria-label="Task options"
        title="Task options"
      >
        <Settings2 aria-hidden />
      </button>
    </header>
  );
}
